import { configFetch as fetch } from '@meiqia/utils';

// 功能权限
export const getFunctionPerms = () => {
  return fetch({
    url: '/enterprise/functions',
    method: 'get'
  });
};
